export default __webpack_public_path__ + "static/media/copy-red.bc921c7c.svg";